"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/portal.ts
var _portal = require('@ariakit/react-core/portal/portal');
var _portalcontext = require('@ariakit/react-core/portal/portal-context');




exports.Portal = _portal.Portal; exports.PortalContext = _portalcontext.PortalContext;
